'use client';

import React, { createContext, useContext } from 'react';
import { ExtendedRequestContext } from '../utils/localization-helpers/types/RequestContext';
import { ILocalizationProviderProps } from './types/ILocalizationProviderProps';
import { useCartStore } from '../store/cart';

const LocalizationContext = createContext<ExtendedRequestContext | undefined>(undefined);

// Custom hook for using the localization context
export const useLocalization = (): ExtendedRequestContext => {
  const context = useContext(LocalizationContext);
  if (!context) {
    throw new Error('useLocalization must be used within a LocalizationProvider');
  }
  return context;
};

// Localization Provider Component
export function LocalizationProvider({ context, children }: ILocalizationProviderProps) {
  const { setCountry, setAreaVariables } = useCartStore();

  // save country and area variables for cart global state, clear cart on country change
  setCountry(context.country);
  setAreaVariables(context.areaVariables);

  return <LocalizationContext.Provider value={context}>{children}</LocalizationContext.Provider>;
}
